import React, { useState } from "react";
import { Box, Modal, Typography, Accordion, AccordionSummary, AccordionDetails } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import FAQData from "../../constants/FAQData";
import AddGameFAQData from "../../constants/AddGameFAQData";

const modalBoxStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  color: 'white',
  backgroundColor: '#333',
  borderRadius: '8px',
  padding: '2rem',
  marginTop: '1rem',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

const FAQAndSettingsModal = ({ onClose, source = 'general' }) => {
  const [modalOpen, setModalOpen] = useState(true);
  const [expandedPanel, setExpandedPanel] = useState(false);

  // Choose FAQ data based on source context
  const faqData = source === 'addgame' ? AddGameFAQData : FAQData;
  const isAddGame = source === 'addgame';

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpandedPanel(isExpanded ? panel : false);
  };

  return (
    <Modal
      open={modalOpen}
      onClose={() => {
        setModalOpen(false)
        onClose && onClose();
      }}
    >
      <Box sx={{
        ...modalBoxStyle,
        width: 600,
        maxHeight: '80vh',
        overflow: 'auto',

      }}>
        <Typography id="modal-modal-title" variant="h6" component="h2" gutterBottom style={{ fontWeight: 'bold', textAlign: 'center', marginBottom: '20px' }}>
          {isAddGame ? 'Content Creation Guide' : 'Frequently Asked Questions'}
        </Typography>

        {faqData.map((faq, index) => (
          <Accordion
            key={index}
            expanded={expandedPanel === `panel${index}`}
            onChange={handleAccordionChange(`panel${index}`)}
            style={{
              backgroundColor: '#444',
              color: 'white',
              marginBottom: '0.5rem'
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls={`faq-content-${index}`}
              id={`faq-header-${index}`}
            >
              <Typography style={{ fontWeight: 'bold', display: 'flex', alignItems: 'center' }}>
                {isAddGame && (
                  <span style={{ 
                    backgroundColor: 'gold', 
                    color: 'black', 
                    borderRadius: '50%', 
                    width: '24px', 
                    height: '24px', 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center', 
                    marginRight: '12px',
                    fontSize: '14px',
                    fontWeight: 'bold'
                  }}>
                    {index + 1}
                  </span>
                )}
                {faq.question}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              {Array.isArray(faq.answer) ? (
                <ul style={{ margin: 0, paddingLeft: '20px', color: 'white' }}>
                  {faq.answer.map((point, pointIndex) => (
                    <li key={pointIndex} style={{ marginBottom: '8px', lineHeight: '1.4' }}>
                      <Typography component="span" style={{ fontSize: '14px' }}>
                        {point}
                      </Typography>
                    </li>
                  ))}
                </ul>
              ) : (
                <Typography>
                  {faq.answer}
                </Typography>
              )}
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>
    </Modal>
  )
}

export default FAQAndSettingsModal;